<template>
  <div class="form_box">
      <circle-navigation v-if="step === 2 || step === 3 || step === 4" :step="step" v-on='$listeners' /> 
      <router-view v-on='$listeners' :header="currentStepHeader" :fullName="fullName" :appName="appName"></router-view>
  </div>
</template>

<script>

import CircleNavigation from "@/components/CircleNavigation.vue";
import Step0 from '@/components/Step0.vue'
import Step1 from '@/components/Step1.vue'
import Step2 from '@/components/Step2.vue'
import Step3 from '@/components/Step3.vue'
import Step4 from '@/components/Step4.vue'
import Step5 from '@/components/Step5.vue'
import Step6 from '@/components/Step6.vue'
import Step7 from '@/components/Step7.vue'
import Step8 from '@/components/Step8.vue'

export default {
  components: {
    circleNavigation: CircleNavigation,
    step0: Step0,
    step1: Step1,
    step2: Step2,
    step3: Step3,
    step4: Step4,
    step5: Step5,
    step6: Step6,
    step7: Step7,
    step8: Step8
  },
  props: {
      step: {
          type: Number,
          default: 0
      },
      currentStepHeader: {
        type: String,
        default: ''
      },
      fullName: {
        type: String,
        default: ''
      },
      appName: {
        type: String,
        default: ''
      },
  }, 
  data() {
    return {};
  },
  methods: {
    preventSubmission: function preventSubmission(e){
      e.preventDefault();
    }
  }
};
</script>